<template>
  <div>
    <v-menu offset-x offset-y left nudge-right="100">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          Ações
        </v-btn>
      </template>
      <v-list
        v-for="(item, index) in showItems"
        :key="index"
      >
        <v-list-item
          @click="item.onClick"
          :disabled="item.disabled"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data () {
    return {
      justificativa: ''
    }
  },
  props: {
    pagamentoId: { type: String, required: true },
    pagamentoStatus: String,
    baixaDisabled: Boolean
  },
  methods: {
    handleEncerrarValidacao () {
      const paramModal = {
          type: 'warning',
          title: 'Concluir validação',
          messageForm: (justificativa) => {
            this.justificativa = justificativa
            this.$emit('encerrarValidacaoClick', this.justificativa)
          },
          btConfirm: { name: 'Concluir', show: true, color: 'primary' },
          btCancel: { name: 'Cancelar', show: true },
          textForm: {
            show: true,
          },
        };
      this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
    }
  },
  computed: {
    isUsuarioTradimus() {
      const isUsuarioTradimus = JSON.parse(sessionStorage.getItem('userData'))
      return isUsuarioTradimus.UsuarioTradimus
    },
    items() {
      return [
      {
          title: 'Concluir validação',
          onClick: this.handleEncerrarValidacao,
          disabled: this.disableEncerrarValidacao,
          showTradimus: true
        },
        {
          title: 'Atualizar para valores divergentes',
          onClick: () => this.$emit('updateToValoresDivergentesClick'),
          disabled: (
            this.$props.pagamentoStatus !== 'identificado' &&
            this.$props.pagamentoStatus !== 'conciliacaoManualTradimus' &&
            this.$props.pagamentoStatus !== 'publicacaoPendente'
          ),
          showTradimus: true
        },
        {
          title: 'Atualizar para faturamento não identificado',
          onClick: () => this.$emit('updateToFaturamentoNaoIdentificadoClick'),
          disabled: (
            this.$props.pagamentoStatus !== 'identificado' &&
            this.$props.pagamentoStatus !== 'conciliacaoManualTradimus' &&
            this.$props.pagamentoStatus !== 'publicacaoPendente'
          ),
          showTradimus: true
        },
        {
          title: 'Baixa de pagamento',
          onClick: () => this.$emit('navigateToBaixa'),
          disabled: this.$props.baixaDisabled,
          showTradimus: true,
          showCliente: false
        },
        {
          title: 'Baixar planilha de resultados',
          onClick: () => this.$emit('baixarPlanilhaClick'),
          disabled: (
            this.isUsuarioTradimus && (
              this.$props.pagamentoStatus === 'conciliacaoAutomaticaTradimus' ||
              this.$props.pagamentoStatus === 'conciliacaoAutomaticaCliente'
            ) ||
            !this.isUsuarioTradimus && (
              this.$props.pagamentoStatus !== 'conciliacaoManualCliente' &&
              this.$props.pagamentoStatus !== 'conclusaoPendente' &&
              this.$props.pagamentoStatus !== 'gerandoArquivos' &&
              this.$props.pagamentoStatus !== 'concluido'
            )
          ),
          showTradimus: true,
          showCliente: true
        }
      ]
    },
    disableEncerrarValidacao () {
      const disableStatus = ['valoresDivergentes', 'faturamentoNaoIdentificado']
      return !disableStatus.includes(this.$props.pagamentoStatus || '')
    },
    showItems () {
      return this.items.filter(item => this.isUsuarioTradimus ? item.showTradimus : item.showCliente)
    }
  }
}
</script>
